// ------------------------------------
// Import SCSS files
// ------------------------------------
import "../sass/template-logement.scss";


$(document).ready(function () {
    $(window).scroll(function () {
        $(".block-section-head").toggleClass("fixed", $(this).scrollTop() > 30)
        $(".container-list").toggleClass("fixed", $(this).scrollTop() > 30)
        $(".block-section-content").toggleClass("fixed", $(this).scrollTop() > 0)
    });

    if (window.matchMedia("(max-width: 1024px)").matches) {
        $(".container-list .dropdown").on( "click", function() {
            $(".steps-list-location").toggleClass("open");
        });

        $(window).scroll(function () {
            $("#mainHeader").toggleClass("navbar-shoot", $(this).scrollTop() > 10);
        });

    };
});